import { displayToast, displayFormErrors, sendAppsignalError } from "../modules/utils";

class PaymentLivestream {
  constructor(node) {
    this.element = node;

    this.contentWrappers = this.element.querySelectorAll(".js-content-wrapper");
    this.loadingWrappers = this.element.querySelectorAll(".js-loading-wrapper");
    this.summaryWrapper = this.element.querySelector(".js-summary-wrapper");
    this.formElement = this.element.querySelector(".js-livestream-form");
    this.submitButton = this.formElement.querySelector("button[type='submit']");

    this.newGuestContainer = this.element.querySelector(".js-guests-new-container");
    this.addNewGuestButton = this.element.querySelector(".js-guests-add-button");
    this.newGuestsWrapper = this.element.querySelector(".js-guests-new-wrapper");
    this.newConfirmedGuestsWrapper = this.element.querySelector(".js-guests-new-confirmed-wrapper");

    this.fetchUrl = new URL(this.element.dataset.fetchUrl, window.location);
    this.newGuestUrl = new URL(this.element.dataset.newGuestUrl, window.location);

    this.initialize();
  }

  initialize() {
    this.addNewGuestButton.addEventListener("click", () => {
      this.loadNewGuestForm();
    });

    this.contentWrappers.forEach((wrapper) => {
      this.addGuestEventListeners(wrapper);
    });

    this.formElement.addEventListener("submit", (e) => {
      e.preventDefault();

      this.submitButton.disabled = true;

      fetch(this.formElement.action, {
        retries: 3,
        retryDelay: 1000,
        method: "POST",
        body: new FormData(this.formElement),
      })
        .then((response) => {
          let { status } = response;
          this.response = response;
          this.formStatus = status;

          if (this.formStatus === 200 || this.formStatus === 422) {
            return response.json();
          }

          throw new Error("Something went wrong");
        })
        .then((data) => {
          if (this.formStatus === 200) {
            window.location.href = data.url;
          }
          if (this.formStatus === 422) {
            displayFormErrors(this.element, data.errorMessages || data);
            displayToast(this.element.dataset.errorMessage);
          }
        })
        .catch((e) => {
          console.error(e);
          displayToast(this.element.dataset.errorMessage);
          sendAppsignalError(e, "PaymentLivestream", {
            response: this.response,
          });
        })
        .finally(() => {
          this.submitButton.disabled = false;
        });
    });
  }

  updateContent() {
    this.loadingWrappers.forEach((wrapper) => {
      wrapper.classList.add("is-loading");
    });

    const formData = new FormData(this.formElement);

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      body: formData,
    })
      .then((response) => {
        let { status } = response;
        this.response = response;
        this.status = status;

        if (this.status === 200 || this.status === 422) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        if (this.status === 422) {
          displayFormErrors(this.element, data.errorMessages || data);
          displayToast(this.element.dataset.errorMessage);
          return; // we return early since there's no point in the other checks
        }

        // We remove the error messages if there are no errors
        displayFormErrors(this.element, {});

        if (data.summary) {
          this.summaryWrapper.innerHTML = data.summary;
        }

        if (data.guestWrapper) {
          const guid = data.guid;
          const oldElement = this.element.querySelector(`[data-guid="${guid}"]`);

          if (oldElement) {
            // We remove the old element to replace it with the new one from the response
            oldElement.remove();
          } else {
            console.warn("Could not find old element");
          }

          const htmlWrapper = document.createElement("div");
          htmlWrapper.innerHTML = data.guestWrapper;

          const newGuestHtml = htmlWrapper.firstChild;

          this.newConfirmedGuestsWrapper.appendChild(newGuestHtml);
          window.Beyuna.initClasses(newGuestHtml);
          this.addGuestEventListeners(newGuestHtml);
        }
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "PaymentLivestream", {
          response: this.response,
        });
      })
      .finally(() => {
        this.loadingWrappers.forEach((wrapper) => {
          wrapper.classList.remove("is-loading");
        });
      });
  }

  addGuestEventListeners(scope) {
    const attendanceTypeInputs = scope.querySelectorAll(".js-attendance-type-input");
    const deleteButton = scope.querySelector(".js-guests-remove-button");

    attendanceTypeInputs.forEach((input) => {
      input.addEventListener("change", () => {
        // We wait for the dom to re-enable the inputs
        setTimeout(() => {
          this.updateContent();
        }, 0);
      });
    });

    if (deleteButton) {
      deleteButton.addEventListener("click", () => {
        scope.remove();
        this.updateContent();
      });
    }
  }

  loadNewGuestForm() {
    this.newGuestContainer.classList.add("is-loading");

    fetch(this.newGuestUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        const { html } = data;
        const newId = Date.now();
        const htmlWrapper = document.createElement("div");

        htmlWrapper.id = newId;
        htmlWrapper.innerHTML = html;

        this.newGuestsWrapper.appendChild(htmlWrapper);

        const newFormElement = document.getElementById(newId);

        window.Beyuna.initClasses(newFormElement);
        this.addGuestEventListeners(newFormElement);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetchGuest);
        window.Appsignal.sendError(e);
      })
      .finally(() => {
        this.newGuestContainer.classList.remove("is-loading");
      });
  }
}

const paymentLivestreamElement = document.querySelector("[data-js='payment-livestream']");

if (paymentLivestreamElement) {
  new PaymentLivestream(paymentLivestreamElement);
}
